import { Box, styled } from "@mui/material";
import { IStyledHeaderProps } from "./types";

const StyledHeader = styled(Box)<IStyledHeaderProps>(({theme})=>({
    
}))

export {StyledHeader}